export default __webpack_public_path__ + "static/media/butterfly3.2fe37327.png";